import Vue from 'vue';

const state = {
    team: [],
    isDownloadingTeam: false,
    agents: [],
    isDownloadingAgents: false,
    isExportingAgents: false,
    isAddingAgent: false,
    communityAgents: null,
    isDownloadingCommunityAgents: false,
    isConnectingToCommunityAgents: false,
    customers: [],
    teamLabels: {},
    customersLabels: {},
    roles: [],
    contactTypes: [],
    selectedPerson: null,
    clonedAgent: {},
    newAgentSetup: {
        email: '',
        brandName: '',
        place: '',
    },
    isLoadingAssociatedAgent: false,
    peopleInviteStatus: [
        {
            id:"0",
            label:"OFFLINE",
            colorClass:"border-medium bg-medium",
            actionLabel: 'Invite to join Pluralo',
            actionClass:"blue",
        },
        {
            id:"5",
            label:"AVAILABLE",
            colorClass:"bg-lightest border-medium color-1",
            actionLabel: 'Connect',
            actionClass:"green",
        },
        {
            id:"10",
            label:"PENDING",
            colorClass:"bg-lightest border-medium dark"
        },
        {
            id:"15",
            label:"CONNECTED",
            colorClass:"bg-lightest border-medium color-3"
        },
        {
            id:"20",
            label:"Connection Refused",
            colorClass:"bg-lightest border-medium color-6"
        },
        {
            id:"25",
            label:"Protocol Canceled",
            colorClass:"bg-lightest border-medium color-6"
        },
    ],
    protocolStatus: [
        {
            id: 0,
            label: "CONNECTED",
            colorClass:"bg-lightest border-medium color-3"
        },
        {
            id: 1,
            label: "CONNECTED",
            colorClass:"bg-lightest border-medium color-3"
        },
        {
            id: 5,
            label: "BLOCKED",
            colorClass:"bg-lightest border-dark dark"
        },
        {
            id: 10,
            colorClass: "REMOVED"
        },
    ],
    depositOptions: [
        {
            "id":0,
            "description":"Fixed amount (total)"
        },
        {
            "id":1,
            "description":"Percentage"
        },
        {
            "id":2,
            "description":"Percentage is equal to Commission"
        }
    ],
    requirePaymentOptions: [
        { "id": 1, "description": "Require payment of full amount" },
        { "id": 2, "description": "Require payment of deposit" },
        { "id": 3, "description": "No payment required" }
    ],
    isGettingAgentInfo: false,
    selectedUnknownAgentId: null,
    isUpdatingAgent: false,
    sellers: [],
    isLoadingSellers: false
};

const getters = {
    getIsDownloadingTeam: (state) => state.isDownloadingTeam,
    getIsLoadingSellers: (state) => state.isLoadingSellers,
    getSellers: (state) => state.sellers,
    getTeam: (state) => state.team,
    getTeamLabels: (state) => state.teamLabels,
    getAgents: (state) => state.agents,
    getCustomers: (state) => state.customers,
    getCustomersLabels: (state) => state.customersLabels,
    getSelectedPerson: (state) => state.selectedPerson,
    getClonedAgent: (state) => state.clonedAgent,
    getNewAgentSetup: (state) => state.newAgentSetup,
    getIsLoadingAssociatedAgent: (state) => state.isLoadingAssociatedAgent,
    getInviteStatusTypes: (state) => state.peopleInviteStatus,
    getProtocolStatusTypes: (state) => state.protocolStatus,
    filterAgentsByType: (state) => type => {
        return state.agents.filter(agent => agent.type === type);
    },
    getAgentById: (state) => id => {
        return state.agents.find(agent => agent.id === id);
    },
    getAgentByChannelType: (state) => id => {
        return state.agents.find(agent => agent.channelType === id);
    },
    getOctoAgent: (state) => info => {
        return state.agents.find(agent => agent.channelType === info.channelType && agent.id === info.channelId);
    },
    getIsGettingAgentInfo: (state) => state.isGettingAgentInfo,
    getDepositOptions: (state) => state.depositOptions,
    getRequirePaymentOptions: (state) => state.requirePaymentOptions,
    getSelectedUnknownAgentId: (state) => state.selectedUnknownAgentId,
    getCommunityAgents: (state) => state.communityAgents,
    getIsConnectingToCommunityAgents: (state) => state.isConnectingToCommunityAgents,
    getIsDownloadingCommunityAgents: (state) => state.isDownloadingCommunityAgents,
    getAddingAgent: (state) => state.isAddingAgent,
    getUpdatingAgent: (state) => state.isUpdatingAgent,
    getIsExportingAgents: (state) => state.isExportingAgents,
};

const actions = {
    downloadSellers: ({ commit }) => {
        state.isLoadingSellers = true;

        return axios.get('/api/supplier/sellers').then(response => {
            state.isLoadingSellers = false;

            if (response.status == 200) {
                commit('SET_SELLERS', response.data);
            }
        }).catch(() => {
            state.isLoadingSellers = false;
        })
    },

    async initAgents ({ commit, dispatch, rootState }) {
        try {
            state.isLoadingAssociatedAgent = true
            let response = await axios.get('/api/people/GetAssociatedAgents', { params: { supplierId: rootState.user.account.supplierId }});
            state.isLoadingAssociatedAgent = false

            if (response && response.status === 200 && response.data) {
                commit('INIT_AGENTS', {
                    agents: response.data,
                    labels: {
                        image: '',
                        name: 'Name',
                        phone: 'Phone',
                        email: 'Email',
                        status: 'Status',
                    }
                });

                return true;
            }

            return false;
        }
        catch (error) {};
    },

    addAgent: ({ state, commit, dispatch, rootState }, options) => {
        state.isAddingAgent = true;
        options = options? options : {}
        let data = {
            supplierId: rootState.user.account.supplierId,
            agent: state.clonedAgent,
            notificationId: state.clonedAgent.notificationId? state.clonedAgent.notificationId : null,
            sendInvite: state.clonedAgent.saveAndSend
        };

        dispatch('startFullScreenLoading');
        return axios.post('/api/people/CreateAgent', data).then((response) => {
            dispatch('stopFullScreenLoading');
            if (response && response.status === 200) {
                commit('UPDATE_LIST', { table: 'agents', object: response.data });

                if(data.notificationId){
                    dispatch('changeNotificationLocally', {
                        notificationId: data.notificationId,
                        dataToChange: {
                            typeStatus: 402
                        }
                    })               
                    dispatch('fetchNotifications',{pagination: 1}).then(response => {
                    dispatch('setBellNotificationList',(response.result))})

                    Vue.toasted.success('Your commissions agreement is on the way');
                } else {
                    Vue.toasted.success('Agent created successfully!');
                }

                dispatch('clearSelectedPerson');
                dispatch('closeModal');
                Vue.router.push({ name: 'agents' });
            }
            state.isAddingAgent = false;
        })
        .catch(function(error) {
            state.isAddingAgent = false;
            dispatch('stopFullScreenLoading');
        });
    },

    inviteAgent:({state, commit, rootState}, payload) => {

        if(payload.agentId){
            commit('SET_AGENT_LOADING', payload.agentId) // adds flag "isLoading" to agent, so we can show a loader
        }

        Vue.toasted.info('Sending invite to agent');
        return axios.post('/api/Supplier/SendInviteToAgent', {
            supplierId: rootState.user.account.supplierId,
            agent: payload.agent
        }).then(response => {
            if (response && response.status === 200) {
                Vue.toasted.success('Invite sent successfully!');
            }
            return response
        }).catch(err => {
            return err
        })
    },

    connectToAgent:({state, commit, rootState}, payload) => {
        commit('SET_AGENT_LOADING', payload.agentId) // adds flag "isLoading" to agent, so we can show a loader
        Vue.toasted.info('Sending connect request');
        return axios.post('/api/Supplier/SendConnectToAgent', {
            supplierId: rootState.user.account.supplierId,
            agent: payload.agent
        }).then(response => {
            if (response && response.status === 200) {
                Vue.toasted.success('Connection request sent successfully!');
            }
            return response
        }).catch(err => {
            return err
        })
    },

    disconnectAgent: ({state, commit, rootState}, payload) => {
        commit('SET_AGENT_LOADING', payload.agentId) // adds flag "isLoading" to agent, so we can show a loader
        return axios.get('/api/Community/SupplierRemoveAgentProtocol', {
            params: {
                supplierId: rootState.user.account.supplierId,
                agentId: payload.agentId
            }
        }).then(response => {
            if (response && response.status === 200) {
                Vue.toasted.success('Agent disconnectect successfully!');
            }
            return response
        }).catch(err => {
            return err
        })

    },

    suspendAgent: ({state, commit, rootState}, payload) => {
        commit('SET_AGENT_LOADING', payload.agentId) // adds flag "isLoading" to agent, so we can show a loader
        return axios.get('/api/Community/SupplierSuspendAgentProtocol', {
            params: {
                supplierId: rootState.user.account.supplierId,
                agentId: payload.agentId
            }
        }).then(response => {
            if (response && response.status === 200) {
                Vue.toasted.success('Agent suspended successfully!');
            }
            return response
        }).catch(err => {
            return err
        })

    },

    unsuspendAgent: ({state, commit, rootState}, payload) => {
        commit('SET_AGENT_LOADING', payload.agentId) // adds flag "isLoading" to agent, so we can show a loader
        return axios.get('/api/Community/SupplierActiveAgentProtocol', {
            params: {
                supplierId: rootState.user.account.supplierId,
                agentId: payload.agentId
            }
        }).then(response => {
            if (response && response.status === 200) {
                Vue.toasted.success('Agent unblocked successfully!');
            }
            return response
        }).catch(err => {
            return err
        })

    },

    updateAgent: ({ state, commit, dispatch, rootState }, payload) => {
        let data = {
            supplierId: rootState.user.account.supplierId,
            agent: payload.agent,
            notificationId: payload.agent.notificationId? payload.agent.notificationId : null,
            sendInvite: payload.sendInvite? payload.sendInvite : null,
        };
        state.isUpdatingAgent = true;
        dispatch('startFullScreenLoading');

        axios.post('/api/people/EditAgent', data).then((response) => {
            dispatch('stopFullScreenLoading');
            if (response && response.status === 200 && response.data) {

                commit('UPDATE_LIST', { table: 'agents', object: response.data.data });
                dispatch('clearSelectedPerson');
                // Reloads agent list
                dispatch('initAgents');

                if (payload.agent.notificationId) {
                    Vue.toasted.success('Your commissions agreement is on the way');
                } else {
                    Vue.toasted.success('Agent updated successfully!');
                }
                
                state.isUpdatingAgent = false;

                if (payload.agent.isOTA == true) {
                    return response
                } else {
                    Vue.router.push({ name: 'agents' });
                    return response
                }
            }
        })
        .catch(function (error) {
            dispatch('stopFullScreenLoading');
            state.isUpdatingAgent = false;
        });
    },

    updateClonedAgent: ({ commit }, fields) => {
        commit('UPDATE_CLONED_AGENT', fields);
    },

    clearClonedAgent: ({ commit }, fields) => {
        commit('CLEAR_CLONED_AGENT');
    },

    resetAgent: ({ commit }) => {
        commit('RESET_AGENT');
    },

    setSelectedPerson: ({ commit }, data) => {
        commit('SET_SELECTED_PERSON', data);
    },

    clearSelectedPerson: ({ commit, dispatch }) => {
        dispatch('closeModal');
        commit('CLEAR_SELECTED_PERSON');
    },

    resetNewAgentSetup: ({ commit }) => {
        commit('RESET_NEW_AGENT_SETUP');
    },

    updateNewAgentSetup: ({ commit }, fields) => {
        commit('UPDATE_NEW_AGENT_SETUP', fields);
    },

    associateAgent: ({commit, rootState}, payload) => {
        axios.post(axios.defaults.baseURL+'api/people/CreateAgentProtocol',{
            supplierId: rootState.user.account.supplierId,
            agent: payload.agent
        }).then((response) => {
            if (response && response.status === 200) {
                Vue.toasted.success(response.data.message);
                //if succeeds adds agent to list, one less request
                commit('ADD_PERSON', { table: 'agents', person: payload.agent });
            }
        }).catch((err) => {
            console.log(err);
        })
    },

    downloadAgents: ({ commit, rootState }) => {
        state.isLoadingAssociatedAgent = true;
        return axios.get('/api/people/GetAssociatedAgents', {
            params: {
                supplierId: rootState.user.account.supplierId
            }
        }).then(response => {
            state.isLoadingAssociatedAgent = false;

            if (response.status == 200) {
                commit('UPDATE_AGENTS', response.data);
            }
        }).catch(() => {
            state.isLoadingAssociatedAgent = false;
        })
    },

    downloadTeam: ({ commit, rootState }) => {
        state.isDownloadingTeam = true
        return axios.get('/api/supplier/memberList', {
            params: {
                supplierId: rootState.user.account.supplierId
            }
        }).then(response => {
            state.isDownloadingTeam = false
            if (response.status == 200) {
                // Everytime we download "team" from API we look for the current user and update his sales channel
                let foundMe = response.data.filter(responseMenber => {
                    return responseMenber.id == rootState.user.account.id
                })[0]

                if (foundMe) {
                    rootState.user.account.salesChannel = foundMe.salesChannel
                }

                commit('UPDATE_TEAM', response.data)
            }
        }).catch(err => {
            state.isDownloadingTeam = false
        })
    },

    getAgentInfo: ({state, rootState}, payload) => {
        state.isGettingAgentInfo = true
        return axios.get('/api/Community/GetAgentDetails', {
            params: {
                supplierId: rootState.user.account.supplierId,
                agentId: payload.agentId
            }
        }).then(response => {
            state.isGettingAgentInfo = false
            return response
        }).catch(err => {
            state.isGettingAgentInfo = false
            return err
        })
    },

    openUnkownAgent: ({state, dispatch}, payload) => {
        dispatch('openModal', 'agentUnknownView')
        state.selectedUnknownAgentId = payload.agentId
    },

    downloadCommunityAgents: ({commit, state, rootState}, payload) => {
        state.isDownloadingCommunityAgents = true
        return axios.get('/api/Community/GetAgentsToSupplier', {
            params: {
                supplierId: rootState.user.account.supplierId,
                search: payload
            }
        }).then(response => {
            state.isDownloadingCommunityAgents = false;
            
            if (response.status == 200) {
                commit('UPDATE_COMMUNITY_AGENTS', response.data);
            }

            return response.data;
        }).catch(err =>{
            state.isDownloadingCommunityAgents = false;
            
            return err;
        })
    },

    connectCommunityAgent: ({state, commit, rootState}, payload) => {
        state.isConnectingToCommunityAgents = true
        return axios.post('/api/Community/SendConnectDefaultToAgent',{
            supplierId: rootState.user.account.supplierId,
            agent: payload.agent
        }).then(response => {
            state.isConnectingToCommunityAgents = false
            return response
        }).catch(err => {
            state.isConnectingToCommunityAgents = false
            return err
        })
    },

    exportAgents: ({ state, rootState }) => {
        state.isExportingAgents = true
        return axios.get('/api/people/ExportAssociatedAgents', {
            params: {
                supplierId: rootState.user.account.supplierId,
            },
            responseType: 'blob'
        }).then(response => {
            state.isExportingAgents = false;

            return response.status === 200 ? response : false;
        }).catch(err => {
            state.isExportingAgents = false;
            return err;
        })
    },
}

const mutations = {
    SET_SELLERS: (state, data) => {
        state.sellers = data
    },

    INIT_TEAM: (state, data) => {
        state.team = data.team;
        state.teamLabels = data.labels;
    },

    INIT_AGENTS: (state, data) => {
        state.agents = data.agents;
    },

    ADD_PERSON: (state, data) => {
        state[data.table].push(data.person);
    },

    RESET_AGENT: (state) => {
        var agent = {
            name: null,
            code: null,
            email: null,
            phone: null,
            role: null,
            image: '',
            website: null,
            facebook: null,
            twitter: null,
            permissions: {
                book: null
            },
            company: {
                name: null,
                vat: null,
                address: null,
                zip: null,
                place: null
            },
            transportation: {
                pickup: null,
                area: null
            },
            contacts: [
                { type: null, email: null, phone: null },
            ]
        }

        state.selectedPerson = agent;
    },

    SET_SELECTED_PERSON: (state, payload) => {
        state.selectedPerson = payload;

    },

    // Updates a set of fields in an object
    UPDATE_PERSON: (state, data) => {
        if (state[data.object] === undefined || !state[data.object]) {
            state[data.object] = {};
        }

        Object.keys(data.fields).forEach((key) => {
            Vue.set(state[data.object], key, data.fields[key]);
        });
    },

    // Updates the list of objects with a newly created/updated one
    UPDATE_LIST: (state, data) => {
        let target = state[data.table].find(item => item.id === data.object.id);

        // Update or create
        if (target) {
            Object.keys(data.object).forEach((key) => {
                Vue.set(target, key, data.object[key]);
            });
        }
        else {
            state[data.table].push(data.object);
        }
    },

    CLEAR_SELECTED_PERSON: (state) => {
        state.selectedPerson = null;
    },

    UPDATE_CLONED_AGENT: (state, fields) => {
        Object.keys(fields).forEach((key) => {
            Vue.set(state.clonedAgent, key, fields[key]);
        });
    },

    CLEAR_CLONED_AGENT: (state) => {
        state.clonedAgent = {}
    },

    RESET_NEW_AGENT_SETUP: (state) => {
        state.newAgentSetup = {
            saveAndSend: true,
            name: null,
            brandName: null,
            contactFinancialEmail: '',
            contactFinancialPhone: '',
            contactSalesEmail: '',
            contactSalesPhone: '',
            contactOthersEmail: '',
            contactOthersPhone: '',
            note: '',
            address: '',
            country: null,
            vat: '',
            zip: '',
            place: '',
            transportation: {},
            contacts: [],
            email: '',
            phone: '',
            role: null,
            payment: 1,
            deposit: null,
            imageLogo: null,
            imageLogoBase64: null,
            locationMain: null,
            agentSize: null,
            salesChannel: null,
            bookPermission: false,
            DepositCurrency: "€",
            SalesStore: false,
            SalesWebsite: false,
            SalesHotel: false,
            currency: "€",
            timezone: null,
            slogan: "",
            website: "",
            facebook: "",
            twitter: "",
            pluraloUrl: "",
            isWorkflowAllowedToSendEmails: true,
        }
    },

    UPDATE_NEW_AGENT_SETUP: (state, fields) => {
        Object.keys(fields).forEach((key) => {
            Vue.set(state.newAgentSetup, key, fields[key]);
        });
    },

    UPDATE_AGENTS: (state, payload) => {
        payload.map(agent => {
            agent.isLoading = false
        })

        state.agents = payload
    },

    PUSH_AGENT_TO_AGENTS: (state, agent) => {
        state.agents.push(agent)
    },

    UPDATE_TEAM: (state, payload) => {
        state.team = payload
    },

    SET_AGENT_LOADING: (state, agentId) => {
        let selectedAgent = state.agents.find(agent => {
            return agent.id == agentId
        })

        if (selectedAgent) {
            selectedAgent.isLoading = true
        }
    },

    UPDATE_COMMUNITY_AGENTS: (state, payload) => {
        state.communityAgents = payload;
      
        state.communityAgents.agentDTOList.forEach(function (communityAgent) {
            state.agents.forEach(function (myAgent) {
                if (communityAgent.email === myAgent.email) {
                    if (communityAgent.inviteStatus !== myAgent.inviteStatus) {
                        Vue.set(communityAgent, 'inviteStatus', myAgent.inviteStatus);
                    }
                    if (communityAgent.protocolStatus !== myAgent.protocolStatus) {
                        Vue.set(communityAgent, 'protocolStatus', myAgent.protocolStatus);
                    }
                }
            });
        });
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/people.js